import DynamicService from "@/services/DynamicService";
import router from "@/router";

const defaultState = () => ({
  players: [],
  player: {},
  currentPlayerId: "",
  playerLoaded: false,
  isLoading: false,
  isLoaded: false,
});

const state = defaultState();

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  GET_PLAYERS(state, players) {
    state.players = players;
    state.isLoaded = true;
    state.isLoading = false;
  },
  GET_PLAYER(state, player) {
    state.player = player;
    state.playerLoaded = true;
  },
  SET_CURRENT_PLAYER(state, id) {
    state.currentPlayerId = id;
  },
  INVALIDATE(state) {
    state.isLoaded = false;
  },
};

const actions = {
  async getPlayers({ commit, state }, forceRefresh = false) {
    if (state.isLoaded && !forceRefresh) {
      return state.players;
    }

    if (state.isLoading) {
      return new Promise((resolve) => {
        const checkLoading = setInterval(() => {
          if (!state.isLoading) {
            clearInterval(checkLoading);
            resolve(state.players);
          }
        }, 50);
      });
    }

    commit("SET_LOADING", true);
    try {
      const players = await DynamicService.getPlayers();
      commit("GET_PLAYERS", players);
      return players;
    } catch (error) {
      commit("SET_LOADING", false);
      throw error;
    }
  },
  async getPlayer({ commit }, id) {
    const player = await DynamicService.getPlayer(id);
    commit("GET_PLAYER", player);
  },
  setCurrentPlayer({ commit }, id) {
    commit("SET_CURRENT_PLAYER", id);
  },
};

const getters = {
  dynamicPlayers: (state) => state.players,
  dynamicPlayer: (state) => state.player,
  currentPlayer: (state) => {
    if (state.currentPlayerId === '') {
      return state.players.find(
        (player) =>
          player._id ===
          (router.currentRoute.params && router.currentRoute.params.playerId)
      );
    } else {
      return state.players.find((player) => player._id === state.currentPlayerId);
    }
  },
  dynamicPlayerLoaded: (state) => state.playerLoaded,
  isLoaded: (state) => state.isLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
